const componentTablesMixin = {
    computed: {
        componentIds() {

            if (!this.clusterId) {
                console.error('A component table must have a cluster property set.');
                return [];
            }

            return this.$store.state.components.clusters[this.clusterId].components;
        },

        componentDataPoints() {
            return this.$store.state.components.componentDataPoints;
        },

        clusterTotals() {
            if (!this.clusterId) {
                console.error('A component table must have a clusterId property set.');
                return {};
            }

            return this.$store.state.components.clusterTotals[this.clusterId];
        },

        components() {
            return this.$store.state.components.components;
        },

        clusters() {
            return this.$store.state.components.clusters;
        }
    },

    props: ['clusterId']
};

export default componentTablesMixin;
